import { PetProfileFormValues } from '@app/core/models';
import { Pathology } from '@app/core/models/pathology';
import { PetBody } from '@app/core/models/pet-body';
import { CountryCode } from '../enums/country-code.enum';

export function buildPetDraftFromPetFormValues(
  petProfileFormValues: PetProfileFormValues | null,
  vetId: string,
  country: string,
  pathologies?: Pathology[] | null,
): PetBody {
  const { birthdate, breed, gender, name, neutered, reproductionStatus, speciesCode, mixed } = petProfileFormValues ?? {};
  const petBody: PetBody = {
    birth: {
      date: birthdate,
    },
    breedCode: breed,
    genderCode: gender,
    name,
    neutered,
    isPurebred: mixed === false || undefined,
    reproductionStatusCode: reproductionStatus,
    speciesCode,
    pathologies: (pathologies ?? []).map((pathology) => pathology.value),
    appCode: 'VS',
    type: 'clinic',
    country: CountryCode[country],
    vetId,
  };

  return petBody;
}
